'use client';

import React from 'react';
import { type FC, useEffect } from 'react';
import { TolgeeBase } from './shared';
import { TolgeeProvider, useTolgeeSSR } from '@tolgee/react';
import type { TolgeeStaticData } from '@tolgee/react';

type Props = {
  locales: TolgeeStaticData;
  locale: string;
  children: React.ReactNode;
};

const tolgee = TolgeeBase().init();

export const TolgeeNextProvider: FC<Props> = ({ locale, locales, children }) => {
  const tolgeeSSR = useTolgeeSSR(tolgee, locale, locales);

  useEffect(() => {
    const { unsubscribe } = tolgeeSSR.on('permanentChange', () => {});

    return () => unsubscribe();
  }, [tolgeeSSR]);

  return (
    <TolgeeProvider tolgee={tolgeeSSR} options={{ useSuspense: false }}>
      {children}
    </TolgeeProvider>
  );
};
